import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { reducer as toastrReducer } from 'react-redux-toastr'

import AppState from './AppStateReducer'
import CurrentSession from './CurrentSessionReducer'
import Drawer from './DrawerReducer'
import LayoutContent from './LayoutContentReducer'
import Router from './ReduxRouterReducer'

export default (history) => {
  let reducers = {
    router: Router,
    CurrentSession: CurrentSession,
    LayoutContent: LayoutContent,
    AppState: AppState,
    Drawer: Drawer,
    form: formReducer,
    toastr: toastrReducer
  }

  return combineReducers(reducers)
}
